module.exports = __webpack_public_path__ + "img/zp-banner.e38a5361.png";